<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">MCD-SRM</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
        <el-form-item prop="emplid">
          <el-input v-model="ruleForm.emplid" placeholder="username">
            <el-button slot="prepend" icon="fa fa-user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="password" v-model="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')">
            <el-button slot="prepend" icon="fa fa-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { localLogin } from "../../api/login";
import { setUser } from "@/store/main";
import { getMenu } from "@/api"

export default {
  data: function () {
    return {
      ruleForm: {
        emplid: 'test001',
        password: 'Pass1234'
      },
      rules: {
        emplid: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          localLogin(this.ruleForm).then((res) => {
            let user = res.data.user;
            //let token ='Bearer '+ user.id_token;
            localStorage.setItem('ms_username', user.name);
            localStorage.setItem('ms_userCd', user.userCd);
            localStorage.setItem('ms_userId', user.tmUserId);
            localStorage.setItem('groupableSupplier', user.groupableSupplier);
            this.$store.commit(setUser, user);
            //将用户标识存入localStorage
            localStorage.setItem('ms_emplFlag', user.emplFlag);
            //将用户角色存入localStorage
            localStorage.setItem('ms_roles', JSON.stringify(user.roleCodes));
            //将用户权限存入localStorage
            localStorage.setItem('ms_Permission', JSON.stringify(user.funCodes));
            localStorage.setItem('ms_DataScope', JSON.stringify(user.dataScope));
            //国际化语言
            if (!!user.userWorkLanguage && (user.userWorkLanguage == 'en_US' || user.userWorkLanguage == 'en-US')) {
              this.$i18n.locale = 'en-US';
              localStorage.setItem('userWorkLanguage', 'en-US');
            } else {
              this.$i18n.locale = 'zh-CN';
              localStorage.setItem('userWorkLanguage', 'zh-CN');
            }
            localStorage.setItem('emplid', user.emplid);
            if (user.supplier) {
              localStorage.setItem('supplierObj', JSON.stringify(user.supplier));
            } else {
              localStorage.removeItem("supplierObj");
            }
            this.getMenu()

          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getMenu() {
      getMenu().then(res => {
        console.log("GY🚀 ~ file: login.vue:90 ~ getMenu ~ res:", res);
        if (res.data.subs[0].subs && res.data.subs[0].subs.length > 0) {
          this.$router.push(res.data.subs[0].subs[0].index);
        }
      })
    }
  }
}
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/login_bg.jpg);
  background-size: 100%;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
